<template>
  <el-header class="header">
    <el-row class="header-content" type="flex" align="middle">
      <el-col :span="6" class="logo">
        <router-link :to="{name:indexName}">
          <h2>{{logo}}</h2>
        </router-link>
      </el-col>
      <el-col :span="12">
        <ul class="el-menu">
          <li :index="item.id" v-for="item in menus" @click="toggle(item.id)" :class="{'is-active':item.id==checkId}">
            <router-link :to="item.url">{{item.name}}</router-link>
          </li>
        </ul>
      </el-col>
      <el-col :span="6" class="entry">
        <ul class="el-menu-1" v-show="!isLogin">
          <li :index="item.id" v-for="item in userEntry" @click="clicked(item.id)" :class="{'is-active':item.id==checkEntry}">
            <router-link :to="{name:item.link}">
              <el-button type="primary">{{item.name}}</el-button>
            </router-link>
          </li>
        </ul>
        <el-row class="logout" v-show="isLogin">
          <el-col :span="24">
            <el-dropdown>
              <span class="el-dropdown-link">
                <el-avatar icon="el-icon-user-solid" style="cursor: pointer;"></el-avatar>
              </span>
              <el-dropdown-menu slot="dropdown">
                <a @click="openLogout">
                  <el-dropdown-item icon="el-icon-delete" style="color: red;">
                    退出登录
                  </el-dropdown-item>
                </a>
              </el-dropdown-menu>
            </el-dropdown>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </el-header>
</template>

<script>
  import bus from '../eventBus/index'
  export default {
    name: "Header",
    data() {
      return {
        logo: 'MARKIT',
        indexName: 'indexLink',
        menus: [{
            id: 1,
            url: '/home',
            name: '首页'
          },
          {
            id: 2,
            url: '/manual',
            name: '手册'
          },
          {
            id: 3,
            url: '/book',
            name: '书籍'
          },
          {
            id: 4,
            url: '/wechat',
            name: '公号'
          },
          {
            id: 5,
            url: '/about',
            name: '关于'
          }
        ],
        userEntry: [{
            id: 1,
            link: 'loginLink', //通过路由里的name实现跳转:to="{name:'link'}"
            name: '登录'
          }
          // ,
          // {
          //   id: 2,
          //   link: 'registerLink',
          //   name: '注册'
          // }
        ],
        checkId: null,
        checkEntry: null,

      }
    },
    methods: {
      toggle(val) {
        this.checkEntry = null;
        this.checkId = val;
        // console.log(this.currentUser);
      },
      clicked(val) {
        this.checkId = null;
        this.checkEntry = val;
      },
      openLogout() {
        this.$confirm('此操作将退出登录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.logout();
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '您已取消!'
          });
        });
      },
      logout() {
        this.$message('您已退出!');
        this.$store.dispatch('logout', false);
        this.$store.commit('getIndex', []);
        this.$store.commit('getHome', []);
        const {
          path
        } = this.$route;

        this.$router.replace({
          path: '/login',
          query: {
            redirect: path
          }
        })
        // location.reload();
      },
      /*路由跳转的方法：*/
      goToRouter() {
        this.$router.go(-1); //上一次浏览的页面
        this.$router.replace('link'); //指定页面
        this.$router.replace({
          name: 'routerName'
        }); //通过路由name跳转指定页面
        this.$router.push('link'); //指定页面（常用）
        this.$router.push({
          name: 'routerName'
        }); //通过路由name跳转指定页面
      }
    },
    watch: {
      /*监听路由，并显示导航栏的选中效果*/
      '$route': {
        handler() {
          let linkName = this.$route.name;
          /*if (linkName === 'homeLink'){
            this.checkId = 1
          } else if (linkName === 'menuLink'){
            this.checkId = 2;
          } else if (linkName === 'aboutLink'){
            this.checkId = 3;
          } else if (linkName === 'adminLink'){
            this.checkId = 4;
          } else if (linkName === 'loginLink'){
            this.checkEntry = 1;
          } else if (linkName === 'registerLink'){
            this.checkEntry = 2;
          }*/
          switch (linkName) {
            case 'homeLink':
              this.checkId = 1;
              this.checkEntry = null;
              break;
            case 'menuLink':
              this.checkId = 2;
              this.checkEntry = null;
              break;
            case 'orderLink':
              this.checkId = 3;
              this.checkEntry = null;
              break;
            case 'aboutLink':
              this.checkId = 4;
              this.checkEntry = null;
              break;
            case 'adminLink':
              this.checkId = 5;
              this.checkEntry = null;
              break;
            case 'loginLink':
              this.checkEntry = 1;
              this.checkId = null;
              break;
            case 'registerLink':
              this.checkEntry = 2;
              this.checkId = null;
              break;
          }
        }
      }
    },
    computed: {
      isLogin() {
        return this.$store.getters.isLogin;
      },
      getUserToken() {
        return this.$store.getters.getUserToken;
      }
    },
  }
</script>

<style scoped lang="less">
  .header {
    position: sticky;
    top: 0;
    z-index: 2;
    width: 100%;
    min-width: 1000px;
    background: #FFFFFF;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    white-space: nowrap;

    .header-content {
      height: 100%;
      margin: 0 auto;
      padding: 0 20px;

      .logo {
        text-align: center;

        h2 {
          color: rgb(64, 158, 255);
        }
      }

      ul.el-menu {
        background: transparent;
        border: 0;

        li {
          display: inline-block;
          line-height: 60px;

          margin: 0 10px;

          a {
            display: block;
            width: inherit;
            height: 100%;
            color: #696969;
            font-size: 14px;
            padding: 0 20px;
          }
        }

        li:hover {
          background: rgb(64, 158, 255);

          a {
            color: #fff;
          }
        }

        .is-active {
          a {
            color: rgb(64, 158, 255);
          }
        }
      }

      .entry {
        text-align: center;
      }

      .logout a {
        cursor: pointer;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Header.vue